/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventaistartpackagehint4Inputs */

const en_eventaistartpackagehint4 = /** @type {(inputs: Eventaistartpackagehint4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text, cover, a second language, two formats and features in one conversation`)
};

const de_eventaistartpackagehint4 = /** @type {(inputs: Eventaistartpackagehint4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text, Cover, englische Fassung, zwei Formate und Funktionen in einem Gespräch`)
};

/**
* | output |
* | --- |
* | "Text, cover, a second language, two formats and features in one conversation" |
*
* @param {Eventaistartpackagehint4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventaistartpackagehint4 = /** @type {((inputs?: Eventaistartpackagehint4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventaistartpackagehint4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventaistartpackagehint4(inputs)
	return de_eventaistartpackagehint4(inputs)
});
export { eventaistartpackagehint4 as "eventAiStartPackageHint" }